'use strict';

var cov_1g2us5xtjc = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/tagsList/tagsList.js',
        hash = 'efa9baba19362dbadad6254230bce38ded8131e2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/tagsList/tagsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 53
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 10
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 35
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 24
                }
            },
            '4': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 75
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 54
                },
                end: {
                    line: 17,
                    column: 73
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 41
                }
            },
            '7': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 36
                }
            },
            '9': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 9
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 30,
                    column: 40
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 41
                }
            },
            '12': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 24
                }
            },
            '13': {
                start: {
                    line: 39,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 36
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 14
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                line: 12
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 16,
                        column: 4
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 25
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 16
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 47
                    },
                    end: {
                        line: 17,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 54
                    },
                    end: {
                        line: 17,
                        column: 73
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 15
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                line: 20
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 24,
                        column: 4
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 33
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 24
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }, {
                    start: {
                        line: 25,
                        column: 8
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                }],
                line: 25
            },
            '1': {
                loc: {
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }, {
                    start: {
                        line: 29,
                        column: 8
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                }],
                line: 29
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TagsListController = function () {
    function TagsListController(NewTagModalService) {
        _classCallCheck(this, TagsListController);

        cov_1g2us5xtjc.f[0]++;
        cov_1g2us5xtjc.s[0]++;

        this.NewTagModalService = NewTagModalService;
        cov_1g2us5xtjc.s[1]++;
        this.filters = {
            /* eslint-disable camelcase */
            is_industry: true
        };
        cov_1g2us5xtjc.s[2]++;
        this.industryFilter = true;
    }

    _createClass(TagsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1g2us5xtjc.f[1]++;
            cov_1g2us5xtjc.s[3]++;

            this._refresh();
        }
    }, {
        key: 'displayNewTagModal',
        value: function displayNewTagModal() {
            var _this = this;

            cov_1g2us5xtjc.f[2]++;
            cov_1g2us5xtjc.s[4]++;

            this.NewTagModalService.display().then(function (tag) {
                cov_1g2us5xtjc.f[3]++;
                cov_1g2us5xtjc.s[5]++;
                return _this.tags.$add(tag);
            });
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_1g2us5xtjc.f[4]++;
            cov_1g2us5xtjc.s[6]++;

            this.tags.$refresh(this.filters);
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_1g2us5xtjc.f[5]++;
            cov_1g2us5xtjc.s[7]++;

            if (angular.isArray(value)) {
                cov_1g2us5xtjc.b[0][0]++;
                cov_1g2us5xtjc.s[8]++;

                value = value.join(',');
            } else {
                cov_1g2us5xtjc.b[0][1]++;
            }

            cov_1g2us5xtjc.s[9]++;
            if (value === null) {
                cov_1g2us5xtjc.b[1][0]++;
                cov_1g2us5xtjc.s[10]++;

                delete this.filters[filter];
            } else {
                cov_1g2us5xtjc.b[1][1]++;
                cov_1g2us5xtjc.s[11]++;

                this.filters[filter] = value;
            }

            cov_1g2us5xtjc.s[12]++;
            this._refresh();
        }
    }]);

    return TagsListController;
}();

cov_1g2us5xtjc.s[13]++;


angular.module('app').component('tagsList', {
    templateUrl: 'app/components/tagsList/tagsList.html',
    controller: TagsListController,
    bindings: {
        tags: '<'
    }
});